import React from "react";
import { dispatch } from "@rematch/core";
import { withRouter } from "react-router-dom";
import {
  Message,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { Form } from "formsy-semantic-ui-react";
import { Card, Button } from "semantic-ui-react";
import {
  singleLineText,
} from "../../../common/RegexValidation";
import _ from "lodash";

class Integrations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownValue: "",
      submitButtonState: false,
      isDirty: false,
    };
  }
  componentDidMount() {
    if (this.props.selectedIntegration === null) {
      if (this.props.match.params.interigationId) {
        dispatch.integrations.setSelectedIntegration(
          this.props.match.params.interigationId
        );
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { selectedIntegration, currentOrganization } = this.props;

    let value = this.state.dropdownValue;

    if (selectedIntegration) {
      if (selectedIntegration._id !== this.props.match.params.interigationId) {
        dispatch.integrations.setSelectedIntegration(
          this.props.match.params.interigationId
        );
      }

      let dropdownOptions = this.getDropdownOptions(selectedIntegration);
      let orgIntegration = this.getOrgIntegration(selectedIntegration, currentOrganization);

      if (dropdownOptions && dropdownOptions.length > 0) {
        if (orgIntegration) {
          const integrationOption = dropdownOptions.find((option) => {
            return option.key == orgIntegration.option
          });
          if (integrationOption) {
            value = integrationOption.value;

          }
        } else {
          value = dropdownOptions[0].value;
        }
      }

    }
    if (value !== this.state.dropdownValue) {
      this.setState({ dropdownValue: value });
    }
    this.setState({ submitButtonState: false });
    this.setState({ isDirty: false });
    
    //this.refs.form.reset();
  }

  updateInegration = async (data) => {
    let payload = {
      data: data,
      selectedOrganisation: this.props.selectedOrganisation,
      selectedIntegration: this.props.selectedIntegration,
      option: this.state.dropdownValue
    };

    delete payload.selectedOrganisation.users;

    await dispatch.integrations.addIntegrationsInOrganization(payload);
    await dispatch.integrations.testIntegration(payload);
  };

  handleSubmit = async (data) => {
    this.updateInegration(data);
  };

  setButtonState = (e, flagValue) => {
    this.setState({ submitButtonState: flagValue });
  }


  updateStateValue() {
    this.setState({
      isDirty: true
    });
  }

  testIntegration = (e, data) => {
    dispatch.integrations.testIntegration(data);
  };

  onDropdownValueSelection = (event, value, index) => {
    this.setState({ dropdownValue: value.value });
  };

  getDropdownOptions = (selectedIntegration) => {
    let dropdownOptions = null;
    if (selectedIntegration) {
      dropdownOptions = selectedIntegration.formBuilder.map((opt) => {
        return {
          key: opt.id,
          value: opt.id,
          text: opt.Label
        }
      });
    }
    return dropdownOptions;
  }

  getOrgIntegration = (currentOrganization, selectedIntegration) => {
    let orgIntegration = null;
    if (
      currentOrganization &&
      selectedIntegration &&
      currentOrganization.integrations &&
      currentOrganization.integrations.length !== 0
    ) {
      currentOrganization.integrations.forEach((o) => {
        if (o.id === selectedIntegration._id) {
          orgIntegration = o;
        }
      });
    }
    return orgIntegration;
  }

  render() {
    const { selectedIntegration, currentOrganization } = this.props;

    const value = this.state.dropdownValue;
    const isDirty = this.state.isDirty;
    const submitButtonState = this.state.submitButtonState;
    const errorLabel = <div className="customErrorLabel" />;

    let dropdownOptions = this.getDropdownOptions(selectedIntegration);
    let orgIntegration = this.getOrgIntegration(currentOrganization, selectedIntegration);


    let formBuilder = null;
    if (!formBuilder && selectedIntegration) {
      formBuilder = selectedIntegration.formBuilder.filter(
        (singleFormBuilder, index) => {
          return singleFormBuilder.id === value;
        }
      );
    }

    return (
      <div className="general-setting">
        <Card>
          <Card.Header>
            {selectedIntegration ? selectedIntegration.label : ""}
          </Card.Header>
          <Card.Content>
            <Form
              id="integrationForm"
              className="formcyForm"
              ref="form"
              onValid={(e) => this.setButtonState(e, true)}
              onInvalid={(e) => this.setButtonState(e, false)}
              onValidSubmit={this.handleSubmit}
            >
              <Dropdown
                className="mar_tb_10"
                placeholder="Select Integration Type"
                fluid
                selection
                onChange={this.onDropdownValueSelection}
                options={dropdownOptions}
                value={value}
              />
              {formBuilder && formBuilder.length > 0 ? (
                formBuilder[0].elements.map((int, index) => {
                  return (
                    <Form.Input
                      required
                      key={index}
                      name={int.label}
                      label={_.startCase(int.label)}
                      placeholder={_.startCase(int.label)}
                      value={orgIntegration ? orgIntegration[int.label] : ""}
                      errorLabel={errorLabel}
                      validations={{ matchRegexp: singleLineText }}
                      onChange={event => this.updateStateValue()}
                      validationErrors={{
                        matchRegexp:
                          "Max limit is 128.No numbers or special characters allowed. No space allowed in starting.",
                        isDefaultRequiredValue: `${_.startCase(
                          int.label
                        )} is required`,
                      }}
                      id={int.label}
                    />
                  );
                })
              ) : null
                //  (
                //   <Loader className="mar_tb_10" active inline />
                // )
              }

              {/* {selectedIntegration ? */}
              {formBuilder && formBuilder.length > 0 ? (
                <Button
                  type="submit"
                  disabled={!(isDirty && submitButtonState)}
                  content={orgIntegration ? "Save & Validate" : "Add"}
                  className="button-submit"
                />
              ) : null}

            </Form>
          </Card.Content>
        </Card>

        {/* {message} */}
        {this.props.testResult && orgIntegration ? (
          <Card>
            <Card.Header> Response </Card.Header>
            <Card.Content>
              {
                this.props.testInProgress ? (
                  <Icon name="circle notch" loading />
                ) : this.props.testResult && this.props.testResult.message == "Error" ? (
                  <Message icon className="bg-red">
                    <Icon name="warning sign" />
                    <Message.Content>
                      <Message.Header>Error</Message.Header>
                      Connection Failed
                    </Message.Content>
                  </Message>
                ) : (
                  <Message icon className="bg-green">
                    <Icon name="thumbs up" />
                    <Message.Content>
                      <Message.Header>Success</Message.Header>
                      Connection Successful
                    </Message.Content>
                  </Message>
                )
              }
            </Card.Content>
          </Card>
        ) : null}
      </div>
    );
  }
}

export default withRouter(Integrations);